"use client";
import React from "react";

const Banner: React.FC = () => {
  const rawDate = process.env.NEXT_PUBLIC_MESSAGE_EXPIRY_DATE || "";
  const rawTime = process.env.NEXT_PUBLIC_MAINTENANCE_START_TIME || "15.00";
  const durationHours = process.env.NEXT_PUBLIC_MAINTENANCE_DURATION_HOURS || "4";
  const messageType = process.env.NEXT_PUBLIC_MESSAGE_TYPE || "maintenance";
  const customMessage = process.env.NEXT_PUBLIC_MESSAGE_TEXT || "";

  const expiryDate = new Date(rawDate);
  expiryDate.setDate(expiryDate.getDate() - 1);
  const formattedDate = expiryDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const [hoursStr, minutesStr = "00"] = rawTime.split(".");
  const timeObj = new Date();
  timeObj.setHours(Number(hoursStr), Number(minutesStr));
  const formattedTime = timeObj.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const currentDate = new Date();
  if (currentDate > new Date(rawDate)) {
    return null; 
  }

  let message;
  if (messageType === "maintenance") {
    message = (
      <>
        🚨 <strong>Scheduled Maintenance Notice:</strong> Our system will undergo maintenance on
        <strong> {formattedDate}, {formattedTime} UK time (GMT+1)</strong>. Services will be unavailable for approximately <strong>{durationHours} hours</strong>.
        Thank you for your patience!
      </>
    );
  } else if (messageType === "holiday") {
    message = (
      <>
        🎉 <strong>Holiday Notice:</strong> {customMessage}
      </>
    );
  }

  return (
    <div className="fixed top-0 left-0 w-full bg-green-500 text-black text-center py-3 font-medium z-50 shadow-md">
      <p className="px-4">{message}</p>
    </div>
  );
};

export default Banner;
